// extracted by mini-css-extract-plugin
module.exports = {"postCard":"PostCard_postCard__2J3pD","date":"PostCard_date__15w5B","title":"PostCard_title__3exu9","snippet":"PostCard_snippet__xffH-"};